import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_workbox_37c0c4aa from 'nuxt_plugin_workbox_37c0c4aa' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_pluginrouting_07a756f8 from 'nuxt_plugin_pluginrouting_07a756f8' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_23bc9112 from 'nuxt_plugin_pluginmain_23bc9112' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_sentryserver_4f40a65c from 'nuxt_plugin_sentryserver_4f40a65c' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_72a63b4a from 'nuxt_plugin_sentryclient_72a63b4a' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_777ba0a3 from 'nuxt_plugin_plugin_777ba0a3' // Source: ./storage/plugin.js (mode: 'all')
import nuxt_plugin_plugins_b18ecf02 from 'nuxt_plugin_plugins_b18ecf02' // Source: ./unhandled-error-notification/plugins.js (mode: 'all')
import nuxt_plugin_nuxtdevicedetectpluginb84c234a_a631f98c from 'nuxt_plugin_nuxtdevicedetectpluginb84c234a_a631f98c' // Source: ./nuxt-device-detect.plugin.b84c234a.js (mode: 'all')
import nuxt_plugin_gtm_18b30d64 from 'nuxt_plugin_gtm_18b30d64' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_vuescrollto_2ac7818a from 'nuxt_plugin_vuescrollto_2ac7818a' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_axios_193adb0e from 'nuxt_plugin_axios_193adb0e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_d72ec294 from 'nuxt_plugin_cookieuniversalnuxt_d72ec294' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_vue_6f186397 from 'nuxt_plugin_vue_6f186397' // Source: ../src/config/vue.js (mode: 'all')
import nuxt_plugin_globals_54607ea6 from 'nuxt_plugin_globals_54607ea6' // Source: ../src/config/globals.js (mode: 'all')
import nuxt_plugin_mixins_5013a1f0 from 'nuxt_plugin_mixins_5013a1f0' // Source: ../src/plugins/mixins (mode: 'all')
import nuxt_plugin_datadog_19a1b94a from 'nuxt_plugin_datadog_19a1b94a' // Source: ../src/plugins/datadog.js (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../src/plugins/axios (mode: 'all')
import nuxt_plugin_usetiful_394a6992 from 'nuxt_plugin_usetiful_394a6992' // Source: ../src/plugins/usetiful (mode: 'client')
import nuxt_plugin_accountSharingLoginNotice_d8984108 from 'nuxt_plugin_accountSharingLoginNotice_d8984108' // Source: ../src/plugins/accountSharingLoginNotice (mode: 'client')
import nuxt_plugin_eventbus_03ab131c from 'nuxt_plugin_eventbus_03ab131c' // Source: ../src/plugins/eventbus (mode: 'all')
import nuxt_plugin_elementui_a6a1b20a from 'nuxt_plugin_elementui_a6a1b20a' // Source: ../src/plugins/element-ui (mode: 'all')
import nuxt_plugin_vueTour_164ca8c8 from 'nuxt_plugin_vueTour_164ca8c8' // Source: ../src/plugins/vueTour (mode: 'all')
import nuxt_plugin_vuemultiselect_f0c5f110 from 'nuxt_plugin_vuemultiselect_f0c5f110' // Source: ../src/plugins/vue-multiselect (mode: 'all')
import nuxt_plugin_numeral_6f934de8 from 'nuxt_plugin_numeral_6f934de8' // Source: ../src/plugins/numeral (mode: 'all')
import nuxt_plugin_date_6a7f6024 from 'nuxt_plugin_date_6a7f6024' // Source: ../src/plugins/date (mode: 'all')
import nuxt_plugin_watchTitle_f8705282 from 'nuxt_plugin_watchTitle_f8705282' // Source: ../src/plugins/watchTitle (mode: 'all')
import nuxt_plugin_onNuxtReady_f5aeefea from 'nuxt_plugin_onNuxtReady_f5aeefea' // Source: ../src/plugins/onNuxtReady (mode: 'all')
import nuxt_plugin_veeValidate_704b86be from 'nuxt_plugin_veeValidate_704b86be' // Source: ../src/plugins/veeValidate.js (mode: 'all')
import nuxt_plugin_inMemoryHistory_024e7cf8 from 'nuxt_plugin_inMemoryHistory_024e7cf8' // Source: ../src/plugins/inMemoryHistory (mode: 'all')
import nuxt_plugin_register_4d0753bc from 'nuxt_plugin_register_4d0753bc' // Source: ../src/plugins/keyboardEvents/register (mode: 'all')
import nuxt_plugin_scroll_3c47dc7a from 'nuxt_plugin_scroll_3c47dc7a' // Source: ../src/plugins/scroll (mode: 'all')
import nuxt_plugin_posthog_6104292c from 'nuxt_plugin_posthog_6104292c' // Source: ../src/plugins/posthog (mode: 'all')
import nuxt_plugin_vmask_3801a64e from 'nuxt_plugin_vmask_3801a64e' // Source: ../src/plugins/v-mask (mode: 'all')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../src/plugins/filters (mode: 'all')
import nuxt_plugin_chat_6a7f03ce from 'nuxt_plugin_chat_6a7f03ce' // Source: ../src/plugins/chat (mode: 'all')
import nuxt_plugin_auth_7b0b973c from 'nuxt_plugin_auth_7b0b973c' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth0_48649ae5 from 'nuxt_plugin_auth0_48649ae5' // Source: ../src/plugins/auth0.js (mode: 'all')
import nuxt_plugin_plugin_5dce4f75 from 'nuxt_plugin_plugin_5dce4f75' // Source: ./vuex-actions-states/plugin.js (mode: 'all')
import nuxt_plugin_nuxtspainit_3c011041 from 'nuxt_plugin_nuxtspainit_3c011041' // Source: ./nuxt-spa-init.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"ImportGenius Lighthouse (Beta)","meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"hid":"description","name":"description","content":"Sign into our Database to gain access to over 100 million ocean, air, and freight shipments from around the globe. We currently offer 14 country databases that include both import and export records."},{"name":"theme-color","content":"#15A2ED"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black"},{"name":"apple-mobile-web-app-title","content":"importgenius"},{"name":"msapplication-TileImage","content":"\u002Fmsapplication-icon-144x144.png"},{"name":"msapplication-TileColor","content":"#000000"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"author","name":"author","content":"with ❤️ Code Ninja"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"isng-nuxt"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"isng-nuxt"},{"hid":"og:description","name":"og:description","property":"og:description","content":"ISNG"}],"link":[{"rel":"preconnect","href":"https:\u002F\u002Fucarecdn.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Fstaging-api.importgenius.com"},{"rel":"preconnect","href":"https:\u002F\u002Fstaging-client-api.importgenius.com"},{"rel":"preconnect","href":"https:\u002F\u002Fstaging-subscription-api.importgenius.com"},{"rel":"preconnect","href":"https:\u002F\u002Fstaging-payment-api.importgenius.com"},{"rel":"preconnect","href":"https:\u002F\u002Fstaging-company-api.importgenius.com"},{"rel":"preconnect","href":"https:\u002F\u002Fstaging-lighthouse.importgenius.com\u002Fnuxt"},{"rel":"preconnect","href":"https:\u002F\u002Fgeniuschat.stg.importgenius.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fucarecdn.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fwww.googleapis.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fstaging-api.importgenius.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fstaging-client-api.importgenius.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fstaging-subscription-api.importgenius.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fstaging-payment-api.importgenius.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fstaging-company-api.importgenius.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fstaging-lighthouse.importgenius.com\u002Fnuxt"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fgeniuschat.stg.importgenius.com"},{"rel":"icon","type":"image\u002Fx-icon  ","href":"\u002Ffavicon.ico"},{"rel":"shortcut icon","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon-152x152.png"},{"rel":"manifest","href":"\u002Fmanifest.json"},{"rel":"preload","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Foverpass\u002Fv3\u002FqFdA35WCmI96Ajtm81lqcs7N4hoiiVI6.woff2","crossorigin":"crossorigin","as":"font"},{"rel":"preload","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Foverpass\u002Fv3\u002FqFdA35WCmI96Ajtm81kOcc7N4hoiiVI6.woff2","crossorigin":"crossorigin","as":"font"},{"rel":"preload","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Foverpass\u002Fv3\u002FqFdH35WCmI96Ajtm81GlU9vgwBcI.woff2","crossorigin":"crossorigin","as":"font"},{"rel":"preload","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Foverpass\u002Fv3\u002FqFdA35WCmI96Ajtm81l6d87N4hoiiVI6.woff2","crossorigin":"crossorigin","as":"font"},{"rel":"preload","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Foverpass\u002Fv3\u002FqFdA35WCmI96Ajtm81keds7N4hoiiVI6.woff2","crossorigin":"crossorigin","as":"font"},{"rel":"preload","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Foverpass\u002Fv3\u002FqFdA35WCmI96Ajtm81kCdc7N4hoiiVI6.woff2","crossorigin":"crossorigin","as":"font"}],"__dangerouslyDisableSanitizers":["script"],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function (w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-NQ9ZX2DL')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-NQ9ZX2DL&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_workbox_37c0c4aa === 'function') {
    await nuxt_plugin_workbox_37c0c4aa(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_07a756f8 === 'function') {
    await nuxt_plugin_pluginrouting_07a756f8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_23bc9112 === 'function') {
    await nuxt_plugin_pluginmain_23bc9112(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_4f40a65c === 'function') {
    await nuxt_plugin_sentryserver_4f40a65c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_72a63b4a === 'function') {
    await nuxt_plugin_sentryclient_72a63b4a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_777ba0a3 === 'function') {
    await nuxt_plugin_plugin_777ba0a3(app.context, inject)
  }

  if (typeof nuxt_plugin_plugins_b18ecf02 === 'function') {
    await nuxt_plugin_plugins_b18ecf02(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtdevicedetectpluginb84c234a_a631f98c === 'function') {
    await nuxt_plugin_nuxtdevicedetectpluginb84c234a_a631f98c(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_18b30d64 === 'function') {
    await nuxt_plugin_gtm_18b30d64(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_2ac7818a === 'function') {
    await nuxt_plugin_vuescrollto_2ac7818a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_193adb0e === 'function') {
    await nuxt_plugin_axios_193adb0e(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_d72ec294 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_d72ec294(app.context, inject)
  }

  if (typeof nuxt_plugin_vue_6f186397 === 'function') {
    await nuxt_plugin_vue_6f186397(app.context, inject)
  }

  if (typeof nuxt_plugin_globals_54607ea6 === 'function') {
    await nuxt_plugin_globals_54607ea6(app.context, inject)
  }

  if (typeof nuxt_plugin_mixins_5013a1f0 === 'function') {
    await nuxt_plugin_mixins_5013a1f0(app.context, inject)
  }

  if (typeof nuxt_plugin_datadog_19a1b94a === 'function') {
    await nuxt_plugin_datadog_19a1b94a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_usetiful_394a6992 === 'function') {
    await nuxt_plugin_usetiful_394a6992(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_accountSharingLoginNotice_d8984108 === 'function') {
    await nuxt_plugin_accountSharingLoginNotice_d8984108(app.context, inject)
  }

  if (typeof nuxt_plugin_eventbus_03ab131c === 'function') {
    await nuxt_plugin_eventbus_03ab131c(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_a6a1b20a === 'function') {
    await nuxt_plugin_elementui_a6a1b20a(app.context, inject)
  }

  if (typeof nuxt_plugin_vueTour_164ca8c8 === 'function') {
    await nuxt_plugin_vueTour_164ca8c8(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemultiselect_f0c5f110 === 'function') {
    await nuxt_plugin_vuemultiselect_f0c5f110(app.context, inject)
  }

  if (typeof nuxt_plugin_numeral_6f934de8 === 'function') {
    await nuxt_plugin_numeral_6f934de8(app.context, inject)
  }

  if (typeof nuxt_plugin_date_6a7f6024 === 'function') {
    await nuxt_plugin_date_6a7f6024(app.context, inject)
  }

  if (typeof nuxt_plugin_watchTitle_f8705282 === 'function') {
    await nuxt_plugin_watchTitle_f8705282(app.context, inject)
  }

  if (typeof nuxt_plugin_onNuxtReady_f5aeefea === 'function') {
    await nuxt_plugin_onNuxtReady_f5aeefea(app.context, inject)
  }

  if (typeof nuxt_plugin_veeValidate_704b86be === 'function') {
    await nuxt_plugin_veeValidate_704b86be(app.context, inject)
  }

  if (typeof nuxt_plugin_inMemoryHistory_024e7cf8 === 'function') {
    await nuxt_plugin_inMemoryHistory_024e7cf8(app.context, inject)
  }

  if (typeof nuxt_plugin_register_4d0753bc === 'function') {
    await nuxt_plugin_register_4d0753bc(app.context, inject)
  }

  if (typeof nuxt_plugin_scroll_3c47dc7a === 'function') {
    await nuxt_plugin_scroll_3c47dc7a(app.context, inject)
  }

  if (typeof nuxt_plugin_posthog_6104292c === 'function') {
    await nuxt_plugin_posthog_6104292c(app.context, inject)
  }

  if (typeof nuxt_plugin_vmask_3801a64e === 'function') {
    await nuxt_plugin_vmask_3801a64e(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (typeof nuxt_plugin_chat_6a7f03ce === 'function') {
    await nuxt_plugin_chat_6a7f03ce(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7b0b973c === 'function') {
    await nuxt_plugin_auth_7b0b973c(app.context, inject)
  }

  if (typeof nuxt_plugin_auth0_48649ae5 === 'function') {
    await nuxt_plugin_auth0_48649ae5(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_5dce4f75 === 'function') {
    await nuxt_plugin_plugin_5dce4f75(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtspainit_3c011041 === 'function') {
    await nuxt_plugin_nuxtspainit_3c011041(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.3.4/src/history/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 1 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
